import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const VictorianConservatory = {
  id: '78',
  name: 'Victorian Conservatory',
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Victorian_Conservatory',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Victorian_Conservatory',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.RANGED_DAMAGE_MOD,
      EffectAmount.asPerLevel([
        1.3, 1.3, 1.3, 1.6, 1.6, 1.6, 1.6, 2, 2, 2,
        2.3, 2.3, 2.3, 2.6, 2.6, 2.6, 2.6, 3, 3, 3,
        3.3, 3.3, 3.3, 3.6, 3.6, 3.6, 3.6, 4, 4, 4,
        4.3, 4.3, 4.3, 4.6, 4.6, 4.6, 4.6, 5, 5, 5,
        5.3, 5.3, 5.3, 5.6, 5.6, 5.6, 5.6, 6, 6, 6,
        6.3, 6.3, 6.3, 6.6, 6.6, 6.6, 6.6, 7, 7, 7
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asCallbackWithLevelAndEra(
        (level, era) => {
          if (level <= 2) {
            return 0;
          }

          const eraData = {
            stoneAge: { init: 5350, step: 950},
            bronzeAge: { init: 9200, step: 1700},
            minoanEra: { init: 13050, step: 2450},
            classicGreece: { init: 16900, step: 3200},
            earlyRome: { init: 20750, step: 3950},
            romanEmpire: { init: 24600, step: 4700},
            byzantineEra: { init: 28450, step: 5450},
            ageOfTheFranks: { init: 32300, step: 6200},
            feudalAge: { init: 36150, step: 6950},
            iberianEra: { init: 40000, step: 7700},
            kingdomOfSicily: { init: 43850, step: 8450},
            highMiddleAges: { init: 47700, step: 9200},
            earlyGothicEra: { init: 51000, step: 9900},
            lateGothicEra: { init: 0, step: 0},
          };
          if (eraData[era] === undefined) {
            console.error(`Unknown era ${era} for building effect on ${VictorianConservatory.name}`);
            return 0;
          }

          return eraData[era].init + (level - 3) * eraData[era].step;
        }
      ).withOutput(ProductionOutputType.FOOD),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput
        .asFlat(1)
        .withOutput(ProductionOutputType.CHEST)
        .withDescription('Produce chest which can include food or event puzzles')
      ,
    ),
  ])
};

export default VictorianConservatory;
